import moment from '@/moment-gp'
import schema from './schema'

export default {
  listGetters: {
    exceptionsSortedAsArray( list ) {

      // TODO: Once we store timezone neutral utc, converting is necessary here!
      // TODO: Should be handles by lib
      // if ( 'date' in  exception ) { exception.date = moment.fromFirestore(exception.date); }
      // if ( 'from' in  exception ) { exception.from = moment.fromFirestore(exception.from); }
      // if ( 'to'   in  exception ) { exception.to   = moment.fromFirestore(exception.to  ); }

      // TODO:
      const dateSorter = (a, b) => {
        let leftDate = moment(a.date || a.from);
        let rightDate = moment(b.date || b.from);
        return leftDate.diff(rightDate)
      }

      // TODO:
      return list.itemsAsArray().sort( dateSorter );
    },
  },
  modelActions: {},
  modelGetters: {},
  staticGetters: {
    exceptions_by_timeslot_collection_id_sorted: ( $models, $registry, $store ) => {

      if ( !( 'timeslotCollectionId' in $store.definedProps ) ) {
        throw new Error('Please define timeslotCollectionId in "with".')
      }

      let timeslotCollectionId = $store.definedProps[ 'timeslotCollectionId' ]

      return this.$models.timeslotException
        .with({ timeslotCollectionId })
        .getList()
        .itemsAsArray()
    },
  },
  staticActions: {},
  schema:  schema
};
